import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet8 = css`
:host {
}
    .image__facet-8 {
        ::slotted(img), ::slotted(picture) {
            object-fit: cover;
            clip-path: polygon( 24.956% 12.495%,49.969% 0%,87.605% 18.824%,87.605% 18.824%,89.832% 20.079%,91.864% 21.514%,93.69% 23.113%,95.303% 24.86%,96.692% 26.739%,97.849% 28.733%,98.765% 30.828%,99.43% 33.006%,99.836% 35.253%,99.973% 37.551%,100% 74.973%,49.969% 100%,24.917% 87.449%,24.917% 87.449%,20.464% 84.954%,16.393% 82.098%,12.725% 78.912%,9.479% 75.43%,6.676% 71.683%,4.335% 67.704%,2.477% 63.525%,1.122% 59.178%,0.29% 54.695%,0% 50.11%,0% 50.11%,0% 50.11%,0.272% 45.509%,1.095% 41.005%,2.449% 36.63%,4.312% 32.418%,6.662% 28.404%,9.477% 24.623%,12.735% 21.107%,16.416% 17.891%,20.497% 15.009%,24.956% 12.495% );
            aspect-ratio: 1;
            width: 100%;
            height: auto;
            z-index: 4;
        }
        .image-shapes-8, .image-shapes-8-bottom {
            display: block;
        }
        .image-shapes-8--crop-mobile {
            display: none;
        }
    }

    .image__facet-8--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            clip-path: polygon( 99.806% 0%,2.875% 0%,2.875% 0%,2.308% 2.198%,1.797% 4.424%,1.344% 6.676%,0.948% 8.953%,0.612% 11.251%,0.336% 13.57%,0.12% 15.908%,-0.034% 18.262%,-0.125% 20.63%,-0.153% 23.011%,-0.153% 23.011%,-0.153% 23.011%,0.137% 30.088%,0.971% 37.005%,2.328% 43.713%,4.188% 50.162%,6.532% 56.303%,9.338% 62.085%,12.588% 67.458%,16.262% 72.374%,20.338% 76.783%,24.797% 80.633%,49.883% 100%,99.978% 61.381%,99.953% 3.637%,99.953% 3.637%,99.951% 3.271%,99.947% 2.905%,99.939% 2.539%,99.929% 2.175%,99.916% 1.811%,99.899% 1.447%,99.88% 1.085%,99.858% 0.724%,99.833% 0.363%,99.806% 0.004% );
            aspect-ratio: 4 / 3;
        }
        .image-shapes-8, .image-shapes-8-bottom {
            display: none;
        }
        .image-shapes-8--crop-mobile {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                clip-path: polygon( 24.956% 12.495%,49.969% 0%,87.605% 18.824%,87.605% 18.824%,89.832% 20.079%,91.864% 21.514%,93.69% 23.113%,95.303% 24.86%,96.692% 26.739%,97.849% 28.733%,98.765% 30.828%,99.43% 33.006%,99.836% 35.253%,99.973% 37.551%,100% 74.973%,49.969% 100%,24.917% 87.449%,24.917% 87.449%,20.464% 84.954%,16.393% 82.098%,12.725% 78.912%,9.479% 75.43%,6.676% 71.683%,4.335% 67.704%,2.477% 63.525%,1.122% 59.178%,0.29% 54.695%,0% 50.11%,0% 50.11%,0% 50.11%,0.272% 45.509%,1.095% 41.005%,2.449% 36.63%,4.312% 32.418%,6.662% 28.404%,9.477% 24.623%,12.735% 21.107%,16.416% 17.891%,20.497% 15.009%,24.956% 12.495% );
                aspect-ratio: 1;
            }
            .image-shapes-8, .image-shapes-8-bottom {
                display: block;
            }
            .image-shapes-8--crop-mobile {
                display: none;
            }
        }
    }

    .image-shapes-8 {
        position: absolute;
        top: 15.5%;
        left: 18%;
        width: 100%;
        height: auto;
        z-index: 1;
    }

    .image-shapes-8-bottom {
        position: absolute;
        top: 8%;
        left: 9.9%;
        width: 110%;
        height: auto;
        z-index: 1;
    }

    .image-shapes-8--crop-mobile {
        position: absolute;
        top: -25%;
        left: -21%;
        width: 129%;
        height: auto;
        z-index: 1;
    }
`;